<template>
  <div>
    <div class="box0">
      <div class="state">
        <b>{{obj.status_str}}</b>
      </div>
    </div>
    <div class="re_total" @click="checks" v-bind:class=" states ? 'states_class' : '' ">

      <div class="re_top">
        <div class="re_top_image">
          <img :src="obj.enroller.user_avatar" alt="">
        </div>
        <div class="re_top_central">
          <h3>{{obj.enroller.alias_name}}</h3>
          <section>
            <span>{{obj.enroller.sex_type}}</span>
            <span>{{obj.enroller.age}}岁</span>
            <p>报名职位：<span>{{obj.job.title}}</span></p>
          </section>
        </div>
        <div>
          <slot name="box"></slot>
          <el-button type="primary"  v-show="!batch" @click="chat(obj)">去聊呗</el-button>
          <el-checkbox v-model="obj.checked"   v-show="batch" @click="doselect"></el-checkbox>
        </div>
      </div>
      <div class="re_heart">
        <div class="re_heart_left">报名地址：</div>

        <ul class="re_heart_right">
          <li v-for="(item,index) in obj.address" :key="index">
            <p>
              <el-radio :label="item.j_address_id" v-model="formData2.j_address_id" v-if="type==2" :disabled="obj.relation_status==10" ></el-radio>
              {{index+1}}.{{item.adname}}
            </p>
          </li>
        </ul>

      </div>

      <div class="re_bottom">
        <div v-if="batch==false">
          <el-button type="text" @click="showResume">查看简历</el-button>
          <el-button type="text" @click="downResume">下载简历</el-button>
          <el-button type="text" @click="homepage">查看主页</el-button>
        </div>

        <div v-if="type==1&&batch==false">
          <el-button type="primary" plain @click="inviteInterview" 
          v-if="obj.status==1"
           >
            邀请面试
          </el-button>

          <el-button type="primary" plain @click="operate(1)"
            v-if="obj.status==0"
          >
            通过
          </el-button>

                    
          <el-button type="primary" plain @click="operate(2)"
          v-if="obj.status==0"
          >
            淘汰
          </el-button>

          <el-button type="primary" plain @click="operate(3)"
            v-if="obj.status==0"
          >
            备选
          </el-button>


        </div>

      </div>

      <div class="reght_lcon" v-if="batch==false">
        <img src="@/assets/director/recruit/images/rightpop.png" alt="" @click="showLog">
      </div>

      <!--悬浮日志-->
      <recruit-popup v-if="isShowLog" @dismissLog="dismissLog" :logs="logs"></recruit-popup>
      
    </div>
</div>
</template>

<script>
//import { addressUpdate,messageList} from "@/api/director/work/recruit/index";



import recruitPopup from "@/views/director/work/recruit/components/recruit-popup.vue";
import contractTypeDialog from './contract-type-dialog.vue';
import recruitEvaluateDialog from './recruit-evaluate-dialog.vue';
import recruitSettlementDialog from './recruit-settlement-dialog.vue';
import { mapGetters } from 'vuex'
//import {ws} from '@/utils/ws'     //引用模块进来


export default {
  components: { recruitPopup,contractTypeDialog,recruitEvaluateDialog,recruitSettlementDialog},
  props: {
    obj: {
      type: Object,
      default: {}
    },

    type: {
      type: Number,
      default: 1
    },

    batch: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isLogin',
      'user_type'// 1 求职 2 招聘
    ]),
  },
  data() {
    return {
      isShowLog:false,
      states:false,
      
      formData2:{// "enroll": [{"enroll_id":41,"j_address_id":2},{"enroll_id":43,"j_address_id":3}],
        j_address_id:'',
        enroll_id:[],
        relation_status:'7'
      },
      logs:[],
    };
  },


  methods:{
    //查看简历
    showResume(){

      this.$message.warning("接口ing")

    },
    
    //下载简历
    downResume(){
      this.$message.warning("接口ing")

    },

    //主页
    homepage(){
      this.$goUserHome(this.obj.user_app_id);
      //this.$router.push({ name: "member-index", query: { id: this.obj.user_app_id } });

    },

    chat(item){
      console.log("this.userInfo",this.userInfo);
      //console.log(this.wsUrl+"?send_user_id=127&receive_user_id="+item.user_app_id+"&link=2");
     // this.$wsConnect(this.wsUrl+"?send_user_id="+this.userInfo.user_id+"&receive_user_id="+item.user_app_id+"&link=2");
      this.ws.initWebSocket(this.wsUrl+"?send_user_id="+this.userInfo.user_app_id+"&receive_user_id="+item.user_app_id+"&link=2&job_id="+item.job_id);
      this.$router.push({ name: "director-chat-info" });

      //this.ws.websocket.close();
    },

    refresh(){
      var that=this;
      that.$emit("refreshData")  ;      
    },


    doselect(){
      var that=this;

      that.$emit("doselect")  ;      
    },

    

    //悬浮日志
    showLog(){
      var that=this;
      //获取日志
      var params={
        enroll_id:that.obj.enroll_id,
      }
      messageList(params).then((response) => {
        console.log(response);
        if(response.code==200){
          that.logs=response.data;
          that.isShowLog=true;

        }else{
           
        }
      });
    },
    //悬浮日志
    dismissLog(){
      this.isShowLog=false;
    },


    checks(){
       this.states=!this.states
    },

    inviteInterview(){
      this.$emit("inviteInterview");
    },

    operate(status){
      if(status==1){
        this.$emit("pass");
      }

      if(status==2){
        this.$emit("out");
      }

      if(status==3){
        this.$emit("alternative");
      }

      

    },




    //确认地址
    confirmAddress(){
      var that=this;
      if(this.formData2.j_address_id==""){
        that.$message.error("请选择地址");
        return false;
      }
      var params={
        enroll:[{
          enroll_id:that.obj.enroll_id,
          j_address_id:that.formData2.j_address_id
        }],
        relation_status:"7"
      }

      addressUpdate(params).then((response) => {
        console.log(response);
        if(response.code==200){
          that.$message.success("操作成功");
          that.$emit("refreshData")  ;         
        }else{
            that.$message.error(response.msg?response.msg:"操作失败");

        }
      });
    },
    

    

  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-radio__label{
    display: none;
}


.box0{
 	width: 0px;
    height: 0px;
    border-top: 60px solid #14aff9;
    border-right: 60px solid transparent;
    position: absolute;
    z-index:99;
    .state{
      width: max-content;
        color:#ffffff;
        transform: rotate(-45deg) translateY(-31px) translateX(32px);
        position: absolute;
        font-size: 10px;
    }
}

.re_total {
  box-sizing: border-box;
  width: 560px;
 height: 250px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 6px;
  margin-bottom: 25px;
  position: relative;

}
.reght_lcon img{
  position: absolute;
  right: 0;
  top: 88px;
  width: 30px;
  display: none;
}
.re_total:hover{
  box-sizing: border-box;
  border: 1px solid #4C71DB;
  
}
.states_class{
  border: 1px solid #4C71DB;
}
.re_total:hover .reght_lcon img{
  display: inline;
}
.re_top {
  height: 54px;
  display: flex;
  justify-content: space-between;
}
.re_top_image {
  width: 54px;
  height: 54px;
  background-color: blanchedalmond;
  margin-right: 17px;
}
.re_top_image img {
  width: 54px;
  height: 54px;
  border-radius: 3px;
}
.re_top_central {
  width: 362px;
  height: 54px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h3 {
    font-size: 19px;
    color: #333333;
  }
  section {
    font-size: 14px;
    display: flex;
    color: #666;
    span {
      margin-right: 25px;
    }
    p {
      span {
        color: #4c71db;
      }
    }
  }
}
.re_heart {
  margin-top: 21px;
  display: flex;
  height: 100px;
  .re_heart_left {
    width: 90px;
    font-size: 14px;
  }
  .re_heart_right {
    width: 445px;
    li {
      font-size: 14px;
      color: #333333;
      opacity: 1;
      margin-bottom: 15px;
    }
  }
}
.re_bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>